import React, { useState } from "react";
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  Avatar,
  IconButton,
  Typography,
  Tooltip,
  TablePagination,
  Button,
} from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import UndoIcon from "@mui/icons-material/Undo";

// Sample cart data
const initialCart = [
  { _id: "c1", title: "Gold Necklace", image: "https://via.placeholder.com/100", price: 1200, category: "Necklaces", quantity: 1 },
  { _id: "c2", title: "Diamond Ring", image: "https://via.placeholder.com/100", price: 3000, category: "Rings", quantity: 2 },
];

const Cart = () => {
  const [cart, setCart] = useState(initialCart);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);

  const handleChangePage = (event, newPage) => setPage(newPage);
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  const handleDelete = (id) => {
    setCart(cart.filter((item) => item._id !== id));
  };

  const handleEdit = (id) => {
    const newQty = prompt("Enter new quantity:");
    if (newQty && !isNaN(newQty) && newQty > 0) {
      setCart((prev) =>
        prev.map((item) =>
          item._id === id ? { ...item, quantity: parseInt(newQty, 10) } : item
        )
      );
    }
  };

  const handleMoveToWishlist = (item) => {
    alert(`${item.title} moved back to wishlist!`);
    handleDelete(item._id);
    // Here you can also call a function to add it back to wishlist state
  };

  return (
    <Paper sx={{ padding: 2, marginTop: 3 }}>
      <Typography variant="h6" gutterBottom>
        Cart
      </Typography>

      {cart.length === 0 ? (
        <Typography align="center" sx={{ mt: 3 }}>
          Your cart is empty 🛒<br />
          Add your favourite jewellery 💍
        </Typography>
      ) : (
        <>
          <TableContainer>
            <Table>
              <TableHead>
                <TableRow>
                  <TableCell>Image</TableCell>
                  <TableCell>Title</TableCell>
                  <TableCell>Category</TableCell>
                  <TableCell>Price</TableCell>
                  <TableCell>Quantity</TableCell>
                  <TableCell>Total</TableCell>
                  <TableCell>Actions</TableCell>
                </TableRow>
              </TableHead>

              <TableBody>
                {cart
                  .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                  .map((item) => (
                    <TableRow key={item._id}>
                      <TableCell>
                        {item.image && (
                          <Tooltip
                            title={
                              <img
                                src={item.image}
                                alt={item.title}
                                style={{ width: 200 }}
                              />
                            }
                          >
                            <Avatar
                              variant="square"
                              src={item.image}
                              alt={item.title}
                            />
                          </Tooltip>
                        )}
                      </TableCell>
                      <TableCell>{item.title}</TableCell>
                      <TableCell>{item.category}</TableCell>
                      <TableCell>{`₹${item.price.toLocaleString()}`}</TableCell>
                      <TableCell>{item.quantity}</TableCell>
                      <TableCell>{`₹${(item.price * item.quantity).toLocaleString()}`}</TableCell>
                      <TableCell>
                        <IconButton onClick={() => handleEdit(item._id)} color="primary">
                          <EditIcon />
                        </IconButton>
                        <IconButton onClick={() => handleDelete(item._id)} color="error">
                          <DeleteIcon />
                        </IconButton>
                        <IconButton onClick={() => handleMoveToWishlist(item)} color="secondary">
                          <UndoIcon />
                        </IconButton>
                      </TableCell>
                    </TableRow>
                  ))}
              </TableBody>
            </Table>
          </TableContainer>

          <TablePagination
            component="div"
            count={cart.length}
            page={page}
            onPageChange={handleChangePage}
            rowsPerPage={rowsPerPage}
            onRowsPerPageChange={handleChangeRowsPerPage}
            rowsPerPageOptions={[5, 10, 25]}
          />
        </>
      )}
    </Paper>
  );
};

export default Cart;
